// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1zrw3","dragIcon":"Choice_dragIcon__1mpby","left":"Choice_left__RcDVv","input":"Choice_input__1GkmC"};